import QuanterPicker from './QuanterPicker.vue';

export default QuanterPicker;
